import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileBottomBar } from "@/components/MobileBottomBar";
import { FinalCtaSection } from "@/components/FinalCtaSection";
import { ServiceRevOpsHero } from "@/components/service-revops-hero";
import { ServicePainAndProof } from "@/components/service-revops-pain-proof";
import { ServiceArchitectureSection } from "@/components/service-revops-architecture";
import { ServiceCostAndProcess } from "@/components/service-revops-cost-process";
import { ServiceTestimonials } from "@/components/service-revops-testimonials";
import { ServiceBuilds } from "@/components/service-revops-builds";
import { ServiceVetting } from "@/components/service-revops-vetting";
import { ServiceMigration } from "@/components/service-revops-migration";
import { ServiceIndustries } from "@/components/service-revops-industries";
import { ServiceSnapshots } from "@/components/service-revops-snapshots";
import {
  ServicePricing,
  ServiceFreeAudit,
  ServiceWhoIAm,
} from "@/components/service-revops-pricing-trust";
import {
  ServiceCaseStudies,
  ServiceFaq,
} from "@/components/service-revops-cases-faq";

export default function ServiceRevOps() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      className="min-h-screen relative pb-[72px] md:pb-0"
      style={{ background: "#FFFFFF" }}
    >
      <MobileBottomBar />
      <Navbar />

      {/* §1 Hero (includes live-proof marquee below CTA) */}
      <ServiceRevOpsHero />

      {/* §2 Pain Diagnosis (CTA inside section) */}
      <ServicePainAndProof />

      {/* §3 Architecture Builds Showcase & Capabilities (CTA inside section) */}
      <ServiceArchitectureSection />

      {/* §4 Cost of Inaction + §5 Build Process (CTA inside section) */}
      <ServiceCostAndProcess />

      {/* System Rescue & Migration (CTA inside section) */}
      <ServiceMigration />

      {/* Testimonials (CTA inside section) */}
      <ServiceTestimonials />

      {/* What I Build Inside GoHighLevel (CTA inside section) */}
      <ServiceBuilds />

      {/* Snapshot Library preview (CTA inside section) */}
      <ServiceSnapshots />

      {/* Industries I Build For (CTA inside section) */}
      <ServiceIndustries />

      {/* How to Vet a CRM Architect (CTA inside section) */}
      <ServiceVetting />

      {/* §6 Pricing & Value */}
      <ServicePricing />

      {/* §7 Free Systems Audit */}
      <ServiceFreeAudit />

      {/* §8 Who I Am / Trust (CTA inside section) */}
      <ServiceWhoIAm />

      {/* §9 Architecture Guides */}
      <ServiceCaseStudies />

      {/* §10 FAQ (CTA inside section) */}
      <ServiceFaq />

      {/* §11 Final CTA */}
      <FinalCtaSection />
      <Footer />
    </main>
  );
}
